import React, { ProviderProps, useEffect, useMemo, useState } from "react";

export type ExecContext = {
    cmds: string[];
    addCommand: (s: string) => void
    removeCommand: (s: string) => void
};

const context = React.createContext<ExecContext>({
    cmds: [],
    addCommand: (s) => {},
    removeCommand: (s) => {}
});

const ExecProvider = ({ children } : ProviderProps<any>) => {
    const addCommand = (s: string) => {
        if (cmds.includes(s))
            return;
        const newCmds = [...cmds];
        newCmds.push(s);
        setCmds(newCmds);
    };
    const removeCommand = (s: string) => {
        if (!cmds.includes(s))
            return;
        const newCmds = [...cmds];
        newCmds.splice(newCmds.indexOf(s), 1);
        setCmds(newCmds);
    }
    const [cmds, setCmds] = useState<string[]>([]);

    const value = useMemo(() : ExecContext => {
        return { cmds, addCommand, removeCommand };
    }, [cmds]);

    return (
        <context.Provider value={value}>
            {children}
        </context.Provider>
    );
};

ExecProvider.context = context;

export default ExecProvider;